export const FETCH_CATEGORY_DETAILS_BEGIN = 'FETCH_CATEGORY_DETAILS_BEGIN';
export const FETCH_CATEGORY_DETAILS_SUCCESS = 'FETCH_CATEGORY_DETAILS_SUCCESS';
export const FETCH_CATEGORY_DETAILS_FAILURE = 'FETCH_CATEGORY_DETAILS_FAILURE';
export const GET_ACTIVE_CATEGORY = 'GET_ACTIVE_CATEGORY';
export const MOBILE_EXPAND_CATEGORY_DETAILS = 'MOBILE_EXPAND_CATEGORY_DETAILS'
